const entity = {
    create_failed: 'Не удалось создать {{name}}.',
    not_exists: '{{name}} не существует.',
    not_exists_with_id: '{{name}} с ID `{{id}}` не существует.',
    not_found: 'Ресурс не существует.',
};
export default entity;
